/* eslint-disable prettier/prettier */
<template>
  <div class="pb-3">
    <div class="text-center"  v-if="popupBatchUpdate.isLoading">
			<img src="@/assets/loading-logo-animation.gif" style="width: 75px"/>
			
			<p class="font-weight-bold">{{$t('THE_SYSTEM_IS_LOADING')}}</p>
		</div>
    <v-row align="center" v-if="!popupBatchUpdate.isLoading" class="m-0">
      <v-col md="8" class="pt-0">
        <v-radio-group
          v-model="popupBatchUpdate.price.action"
          row
          class="mt-0"
          @change="changeAction"
        >
          <!-- <v-radio
            :label="$t('RESTRICTION_BULK_UPDATE')"
            value="massUpdate"
            color="primary"
          ></v-radio> -->
          <v-radio
            :label="$t('UPDATE_BY_ROOM_TYPE')"
            value="updateByRoomType"
            color="primary"
          ></v-radio>
          <v-radio
            :label="$t('RESTRICTION_BULK_UPDATE')"
            value="update"
            color="primary"
          ></v-radio>
          <v-radio
            :label="$t('BULK_DELETE')"
            value="delete"
            color="primary"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col class="text-right pt-0">
        <v-btn color="primary" @click="confirmUpdateSpecialPrice()" :disabled="popupBatchUpdate.isLoading">
        <template
          >{{ $t("UPDATE") }}</template
        >
      </v-btn>
      </v-col>
    </v-row>
    <div class="d-flex px-3 pb-3 w-100 justify-content-between" v-if="!popupBatchUpdate.isLoading">
      <div class="pt-0 w-100" v-if="popupBatchUpdate.price.action !== 'massUpdate'">
        <label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
          {{ $t("ROOM_TYPE") }} *
        </label>
        <v-autocomplete
          item-text="text"
          item-value="value"
          :items="listRoom"
          v-model="popupBatchUpdate.price.selectedRoomType"
          outlined
          chips
          dense
          multiple
          @change="$event => changeRoomSelect($event) & checkProductUpdate()"
        >
        <template v-slot:prepend-item>
					<p class="mx-3 mt-1"> <a
            class="text-primary"
            @click="popupBatchUpdate.price.selectedRoomType = listRoom.map(e => e.value); checkProductUpdate()"
            >{{$t('SELECT_ALL')}}</a> | <a
            class="text-primary"
            @click="popupBatchUpdate.price.selectedRoomType = []"
            >{{$t('UN_SELECT_ALL')}}</a>
          </p>
				</template>
        <template v-slot:selection="{ item, index }">
          <v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
						:input-value="item.selected"
						close
						@click:close="removeChips(index, popupBatchUpdate.price.selectedRoomType)"
						@click="item.select">
            <span>{{ item.text }}</span>
          </v-chip>
          <span v-if="index === 2" class="grey--text caption"
            >(+{{ popupBatchUpdate.price.selectedRoomType.length -2 }})</span
          >
          </template>
          <template slot="no-data">
                <div class="no-data">{{ $t("NO_DATA") }}</div>
          </template>
        </v-autocomplete>
      </div>
      <div class="ml-3 w-100" v-if="popupBatchUpdate.price.action !== 'massUpdate'">
        <label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> {{ $t("SALE_PACKAGE") }} *</label>
        <v-autocomplete item-text="text" item-value="value" :items="planList" v-model.lazy="planSelect" outlined chips dense multiple @change="$event => changeRoomSelect($event) & checkProductUpdate()">
          <template v-slot:prepend-item>
            <p class="mx-3 mt-1"> <a
              class="text-primary"
              @click="planSelect = planList.map(e => e.value); checkProductUpdate()"
              >{{$t('SELECT_ALL')}}</a> | <a
              class="text-primary"
              @click="planSelect = []"
              >{{$t('UN_SELECT_ALL')}}</a>
            </p>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
              :input-value="item.selected"
              close
              @click:close="removeChips(index, planSelect)"
              @click="item.select">
              <span>{{ item.text }}</span>
            </v-chip>
            <span v-if="index === 2" class="grey--text caption"
              >(+{{ planSelect.length - 2 }})</span
            >
          </template>
          <template slot="no-data">
              <div class="no-data">{{ $t("NO_DATA") }}</div>
          </template>
        </v-autocomplete>
      </div>
      <div class=" ml-3 w-100" v-if="popupBatchUpdate.price.action == 'update' || popupBatchUpdate.price.action == 'delete'" >
        <label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
        {{ $t("SALE_CHANNEL") }}*
        </label>
        <v-autocomplete item-text="text" item-value="value" :items="listOTA" v-model="popupBatchUpdate.price.priceByOtasSelected" outlined chips dense multiple @change="$event => changeRoomSelect($event)">
          <template v-slot:prepend-item>
            <p class="mx-3 mt-1"> <a
              class="text-primary"
              @click="popupBatchUpdate.price.priceByOtasSelected = listOTA.map(e => e.value)"
              >{{$t('SELECT_ALL')}}</a> | <a
              class="text-primary"
              @click="popupBatchUpdate.price.priceByOtasSelected = []"
              >{{$t('UN_SELECT_ALL')}}</a>
            </p>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
              :input-value="item.selected"
              close
              @click:close="removeChips(index, popupBatchUpdate.price.priceByOtasSelected)"
              @click="item.select">
              <span>{{ item.text }}</span>
            </v-chip>
            <span v-if="index === 2" class="grey--text caption"
              >(+{{ popupBatchUpdate.price.priceByOtasSelected.length - 2 }})</span
            >
          </template>
          <template slot="no-data">
              <div class="no-data">{{ $t("NO_DATA") }}</div>
          </template>
        </v-autocomplete>
      </div>
    </div>

    <div
      class="config-price"
      v-if="popupBatchUpdate.price.action !== 'massUpdate' && popupBatchUpdate.price.action !== 'updateByRoomType' && !popupBatchUpdate.isLoading"
    >
      <template>
        <div class="w-100">
          <div class="d-sticky h-header-table d-flex">
            <div class="mr-auto"> 	
             
            </div> 
            <div> 	
              <div class="small-gutters d-flex"> 	
                <div class="text-center font-weight-bold" :style="item.code === 'MON' ? 'width: 112px' : 'width: 94px'" v-for="item in popupBatchUpdate.daysOfWeek" :key="item.code">{{ item.value }}</div>
                <div class="text-center font-weight-bold" style="width: 94px" v-if="popupBatchUpdate.price.action != 'delete'">
                  <div class="d-flex">
                    <div class="mr-1">Master product</div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <i class="icon-info fs-14" v-bind="attrs" v-on="on"></i>
                      </template>
                      <span>{{ $t('TOOLTIP_MASTER') }}</span>
                    </v-tooltip>
                  </div>
                </div>	
              </div> 
            </div>
          </div>
          <template
            v-for="(room, roomIndex) in popupBatchUpdate.price.hasRoomRate.filter(temp => popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId)
              && temp.roomRates.filter(item => planSelect.includes(item.ratePlansId) && 
							item.ota.filter(ota => popupBatchUpdate.price.priceByOtasSelected.includes(ota.ota.id)).length > 0).length > 0
            )">
            <div class="px-3 pt-2"
              v-for="(plan, indexPlan) in room.roomRates.filter(item => planSelect.includes(item.ratePlansId) && item.ota.filter(ota => popupBatchUpdate.price.priceByOtasSelected.includes(ota.ota.id)).length > 0)"
            >
              <span class="font-weight-bold text-primary">
                {{ room.romTypeNameI18ns.find(x => x.lang == defaultI18n).name }} - {{ plan.romPlanNameI18ns.find(x => x.lang == defaultI18n).name }}
              </span>
              <p v-if="`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors" class="protection-rate-error text-danger mb-1">{{updateErrors[`${room.roomTypeId}_${plan.ratePlansId}`]}}</p>
              <div v-for="(detail, indexDetail) in plan.ota.filter(ota => popupBatchUpdate.price.priceByOtasSelected.includes(ota.ota.id))" class="mb-3">
                <div class="d-flex mb-1">
                  <div class="pb-0 pt-1 mr-auto">
                    <div
                      class="d-flex align-center h-100 text-primary"
                    >
                      {{
                        detail.ota.otaI18n.find(x => x.lang == defaultI18n).name
                      }}
                    </div>
                  </div>
                  <div class="py-0 text-right" style="width: 734px;">
                    <div class="d-flex justify-content-end">
                      <div class="text-right d-flex justify-content-end">
                        <div class="d-flex align-center justify-content-end d-multiplier" v-if="radioUpdate && radioUpdate !== (room.roomTypeId + '|' + plan.ratePlansId + '|' + detail.ota.id) && popupBatchUpdate.price.action === 'update'">
                          <div class="mr-1">
                            <span class="font-weight-bold"> Master *</span>
                          </div>
                          <div>
                            <currency-ptd 
                              :classC="'input-multiplier v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
                              :options="multiplierOption"
                              v-model.lazy="detail.multiplier" 
                            ></currency-ptd>
                          </div> 
                          <span class="font-weight-bold pl-1 pr-1"> + </span>
                          <div class="mr-1">
                            <currency-ptd 
                              :classC="'input-plus v-input__slot mb-0 mx-input pr-1 py-0 rounded'" 
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              v-model.lazy="detail.plus" 
                            ></currency-ptd>
                          </div>
                          <v-btn color="primary" outlined x-small @click="copyMasterRate(detail)" :title="$t('COPY_BY_FOMULAR')"> 
                            <v-icon size="16">move_down</v-icon>
                          </v-btn>
                        </div>
                        <div class="ml-3 d-flex align-center">
                          <v-btn color="primary" 
                            x-small
                            class="ml-1"
                            :title="$t('COPY')"
                            @click="copyMaster(detail.dates)"
                          >
                          <i class="icon-copy_all fs-16"></i>
                          </v-btn>
                          <v-btn color="primary" 
                            x-small
                            class="ml-1"
                            :title="$t('PASTE')"
                            @click="pasteMaster(detail)" v-if="objectCopy"
                          >
                          <i class="icon-content_paste fs-16"></i>
                          </v-btn>
                        </div>
                      </div>
                      <div class="text-center" style="width: 94px;" v-if="popupBatchUpdate.price.action != 'delete'">
                        <b-form-radio v-model="radioUpdate" v-if="popupBatchUpdate.price.action === 'update'"
                        name="some-radios-bulkUpdate" :value="room.roomTypeId + '|' + plan.ratePlansId + '|' + detail.ota.id"></b-form-radio>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div class="d-flex mb-2" v-for="(date, indDate) in detail.dates" :key="indDate">
                      <div class="pb-0 d-date mr-auto">
                        <template
                          v-if="
                            roomIndex === 0 &&
                              indexDetail === 0 &&
                              indexPlan === 0
                          "
                        >
                          <div class="d-flex align-items-center">
                            <date-picker
                              :disabled-date="notBeforeToday"
                              @input="changDate(detail)"
                              :confirm="true"
                              :confirm-text="$t('CONFIRM')"
                              :clearable="false"
                              :popup-class="'popup-calendar-desktop-detailhotel'"
                              v-model="date.dateSelect"
                              :lang="languageDate"
                              :format="'DD/MM/YYYY'"
                              :shortcuts="[]"
                              range
                              placeholder="Select date range"
                            >
                            </date-picker>
                            <v-btn v-if="detail.dates.length > 1" color="red" @click="removePeriodSpecialPrice(indDate)" class="ml-1" icon small><i class="icon-delete fs-16"></i></v-btn>
                          </div>
                        </template>
                        <template v-else>
                          {{ _moment(date.dateSelect[0]).format("DD/MM/YYYY") }} -
                          {{ _moment(date.dateSelect[1]).format("DD/MM/YYYY") }}
                        </template>
                      </div>
                      <div>
                        <div
                          class="small-gutters"
                          v-if="popupBatchUpdate.price.action === 'update'"
                        >
                          <div class="pb-0 pt-0 d-flex align-items-center">
                            <v-btn color="primary" @click="copyPrice(date)" :title="$t('COPY')" icon small><i class="icon-content_paste_go fs-16"></i></v-btn>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['MON'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')"
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['MON'].disable"
                              v-model.lazy="date['MON'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['TUE'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')"
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['TUE'].disable"
                              v-model.lazy="date['TUE'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['WED'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')"
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['WED'].disable"
                              v-model.lazy="date['WED'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['THU'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')"
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['THU'].disable"
                              v-model.lazy="date['THU'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['FRI'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')"
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['FRI'].disable"
                              v-model.lazy="date['FRI'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['SAT'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')"
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['SAT'].disable"
                              v-model.lazy="date['SAT'].value"
                            />
                          </div>
                          <div class="mr-0">
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['SUN'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')"
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['SUN'].disable"
                              v-model.lazy="date['SUN'].value"
                            />
                          </div>
                        </div>
                        <div class="small-gutters" v-else>
                          <div class="pb-0 pt-0 d-flex">
                            <v-icon
                              size="16"
                              color="primary"
                              @click="copyPrice(date)"
                              class="pr-3"
                              :title="$t('COPY')"
                              >content_paste_go</v-icon
                            >
                            <b-form-select
                                v-model="date['MON'].value"
                                :options="popupBatchUpdate.price.delete.options"
                                value-field="value"
                                text-field="text"
                                :disabled="date['MON'].disable"
                                size="sm"
                                class="w-input-update"
                              ></b-form-select>
                          </div>
                          <div>
                            <b-form-select
                                v-model="date['TUE'].value"
                                :options="popupBatchUpdate.price.delete.options"
                                value-field="value"
                                text-field="text"
                                :disabled="date['TUE'].disable"
                                size="sm"
                                class="w-input-update"
                              ></b-form-select>
                          </div>
                          <div>
                            <b-form-select
                                v-model="date['WED'].value"
                                :options="popupBatchUpdate.price.delete.options"
                                value-field="value"
                                text-field="text"
                                :disabled="date['WED'].disable"
                                size="sm"
                                class="w-input-update"
                              ></b-form-select>
                          </div>
                          <div>
                            <b-form-select
                                v-model="date['THU'].value"
                                :options="popupBatchUpdate.price.delete.options"
                                value-field="value"
                                text-field="text"
                                :disabled="date['THU'].disable"
                                size="sm"
                                class="w-input-update"
                              ></b-form-select>
                          </div>
                          <div>
                            <b-form-select
                                v-model="date['FRI'].value"
                                :options="popupBatchUpdate.price.delete.options"
                                value-field="value"
                                text-field="text"
                                :disabled="date['FRI'].disable"
                                size="sm"
                                class="w-input-update"
                              ></b-form-select>
                          </div>
                          <div>
                            <b-form-select
                                v-model="date['SAT'].value"
                                :options="popupBatchUpdate.price.delete.options"
                                value-field="value"
                                text-field="text"
                                :disabled="date['SAT'].disable"
                                size="sm"
                                class="w-input-update"
                              ></b-form-select>
                          </div>
                          <div class="mr-0">
                            <b-form-select
                                v-model="date['SUN'].value"
                                :options="popupBatchUpdate.price.delete.options"
                                value-field="value"
                                text-field="text"
                                :disabled="date['SUN'].disable"
                                size="sm"
                                class="w-input-update "
                              ></b-form-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center" style="width: 94px;" v-if="popupBatchUpdate.price.action != 'delete'"></div>
                </div>
                <v-row
                  class="mt-0"
                  v-if="roomIndex === 0 && indexDetail === 0 && indexPlan === 0"
                >
                  <v-col class="pt-0 pb-0">
                    <v-btn
                      color="primary"
                      outlined
                      x-small
                      @click="addDatePriodSpecialPrice()"
                    >
                      <i class="icon-add fs-14"></i>
                      <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <hr class="mb-0" />
            </div>
          </template>
        </div>
      </template>
      <template v-if="popupBatchUpdate.price.selectedRoomType.length == 0 || planSelect.length === 0 || popupBatchUpdate.price.priceByOtasSelected.length === 0">
        <v-col class="text-center">
          <p style="color: #484646">{{ $t("NO_DATA") }}</p>
        </v-col>
      </template>
    </div>
    <!-- Caapj nhật theo hạng phòng -->
    <div class="config-price" v-else-if="popupBatchUpdate.price.action === 'updateByRoomType' && !popupBatchUpdate.isLoading">
      <template>
        <div class="w-100">
          <div class="d-sticky h-header-table d-flex">
            <div class="mr-auto"> 	
             
            </div> 
            <div> 	
              <div class="small-gutters d-flex"> 	
                <div class="text-center font-weight-bold" :style="item.code === 'MON' ? 'width: 112px' : 'width: 94px'" v-for="item in popupBatchUpdate.daysOfWeek" :key="item.code">{{ item.value }}</div> 	
                <div class="text-center font-weight-bold" style="width: 94px">
                  <div class="d-flex">
                    <div class="mr-1">Master product</div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <i class="icon-info fs-14" v-bind="attrs" v-on="on"></i>
                      </template>
                      <span>{{ $t('TOOLTIP_MASTER') }}</span>
                    </v-tooltip>
                  </div>
                </div>	
              </div> 
            </div>
          </div>
          <template
            v-for="(room, roomIndex) in popupBatchUpdate.price.hasRoomRate.filter((temp) => popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId) 
            && temp.roomRates.filter(item => planSelect.includes(item.ratePlansId)).length > 0)
						">
            <div class="px-3 pt-2"
              v-for="(plan, indexPlan) in room.roomRates.filter(item => planSelect.includes(item.ratePlansId))"
            >
              <div>
                <div class="d-flex mb-1">
                  <div class="d-date pb-0 pt-1 mr-auto">
                    <div
                      class="d-flex align-center h-100 text-primary"
                    >
                    <span class="font-weight-bold text-primary pr-2">
                      {{ room.romTypeNameI18ns.find(x => x.lang == defaultI18n).name }} - {{ plan.romPlanNameI18ns.find(x => x.lang == defaultI18n).name }}
                    </span>
                    <v-menu
											:close-on-content-click="false"
											:nudge-width="200"
											offset-y
											>
											<template v-slot:activator="{ on, attrs }">
												<v-btn class="btn-outline-custom pr-0" v-bind="attrs" v-on="on" x-small >
													{{$tc('CHANNEL', plan.selectedOta.length.toString())}} <i class="icon-drop-down-list fs-14 ml-2"></i>
												</v-btn>
											</template>

											<v-card>
												<v-list>
													<v-list-item class="px-2" >
														<b-form-input v-model="plan.textSearch" :placeholder="$t('_HOTEL_CHAIN.SEARCH')"></b-form-input>
													</v-list-item>
                          <v-list-item class="px-2">
                            <p class="mx-3 mt-1 mb-0"> <a
                              class="text-primary"
                              @click="plan.selectedOta = plan.ota.map(e => e.ota.id)"
                              >{{$t('SELECT_ALL')}}</a> | <a
                              class="text-primary"
                              @click="plan.selectedOta = []"
                              >{{$t('UN_SELECT_ALL')}}</a>
                              </p>
                          </v-list-item>
												</v-list>
												<v-list>
													<v-list-item v-for="(ota, indOta) in plan.ota.filter(item => item.ota.otaI18n.find((x) => x.lang == defaultI18n).name.toString().toLowerCase().includes( plan.textSearch.toLowerCase()))" 
														style="min-height: 28px !important" class="px-2">
														<v-checkbox v-model="plan.selectedOta" class="mt-0 pt-0"
															:label="ota.ota.otaI18n.find((x) => x.lang == defaultI18n).name" :value="ota.ota.id" 
														></v-checkbox>
													</v-list-item>
												</v-list>
											</v-card>
										</v-menu>
                    </div>
                  </div>
                  <div style="width: 734px;">
                    <div class="text-right d-flex justify-content-end">
                      <div class="d-flex justify-content-end">
                        <div class="d-flex align-center justify-content-end d-multiplier" v-if="radioUpdateByRoomType && radioUpdateByRoomType !== (room.roomTypeId + '|' + plan.ratePlansId)">
                          <div class="mr-1">
                            <span class="font-weight-bold"> Master *</span>
                          </div>
                          <div>
                            <currency-ptd 
                              :classC="'input-multiplier v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
                              :options="multiplierOption"
                              v-model.lazy="plan.multiplier" 
                            ></currency-ptd>
                          </div> 
                          <span class="font-weight-bold pl-1 pr-1"> + </span>
                          <div class="mr-1">
                            <currency-ptd 
                              :classC="'input-plus v-input__slot mb-0 mx-input pr-1 py-0 rounded'" 
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              v-model.lazy="plan.plus" 
                            ></currency-ptd>
                          </div>
                          <v-btn color="primary" outlined x-small @click="copyMasterRate(plan)" :title="$t('COPY_BY_FOMULAR')"> 
                            <v-icon size="16">move_down</v-icon>
                          </v-btn>
                        </div>
                        <div class="ml-3 d-flex align-center">
                          <v-btn color="primary" 
                            x-small
                            class="ml-1"
                            :title="$t('COPY')"
                            @click="copyMaster(plan.dates)"
                          >
                          <i class="icon-copy_all fs-16"></i>
                          </v-btn>
                          <v-btn color="primary" 
                            x-small
                            class="ml-1"
                            :title="$t('PASTE')"
                            @click="pasteMaster(plan)" v-if="objectCopy"
                          >
                          <i class="icon-content_paste fs-16"></i>
                          </v-btn>
                        </div>
                      </div>
                      <div style="width: 94px;" class="text-center">
                        <b-form-radio v-model="radioUpdateByRoomType"
                          name="some-radios-bulkUpdate" :value="room.roomTypeId + '|' + plan.ratePlansId"></b-form-radio>
                      </div>
										</div>
                  </div>
                </div>
                <p v-if="`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors" class="protection-rate-error text-danger mb-1">{{updateErrors[`${room.roomTypeId}_${plan.ratePlansId}`]}}</p>
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <div class="d-flex mb-2" v-for="(date, indDate) in plan.dates" :key="indDate">
                      <div class="pb-0 d-date mr-auto">
                        <template v-if="roomIndex === 0 && indexPlan === 0">
                          <div class="d-flex align-items-center">
                            <date-picker
                              :disabled-date="notBeforeToday"
                              @input="changDate(plan)"
                              :confirm="true"
                              :confirm-text="$t('CONFIRM')"
                              :clearable="false"
                              :popup-class="'popup-calendar-desktop-detailhotel'"
                              v-model="date.dateSelect"
                              :lang="languageDate"
                              :format="'DD/MM/YYYY'"
                              :shortcuts="[]"
                              range
                              placeholder="Select date range"
                            >
                            </date-picker>
                            <v-btn v-if="plan.dates.length > 1" color="red" @click="removePeriodSpecialPrice(indDate)" class="ml-1" icon small><i class="icon-delete fs-16"></i></v-btn>
                          </div>
                        </template>
                        <template v-else>
                          {{ _moment(date.dateSelect[0]).format("DD/MM/YYYY") }} -
                          {{ _moment(date.dateSelect[1]).format("DD/MM/YYYY") }}
                        </template>
                      </div>
                      <div style="width: 734px;">
                        <div class="small-gutters" >
                          <div class="pb-0 pt-0 d-flex align-items-center">
                            <v-btn color="primary" @click="copyPrice(date)" :title="$t('COPY')" icon small><i class="icon-content_paste_go fs-16"></i></v-btn>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['MON'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')" 
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['MON'].disable"
                              v-model.lazy="date['MON'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['TUE'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')" 
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['TUE'].disable"
                              v-model.lazy="date['TUE'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['WED'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')" 
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['WED'].disable"
                              v-model.lazy="date['WED'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['THU'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')" 
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['THU'].disable"
                              v-model.lazy="date['THU'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['FRI'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')" 
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['FRI'].disable"
                              v-model.lazy="date['FRI'].value"
                            />
                          </div>
                          <div>
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['SAT'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')" 
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['SAT'].disable"
                              v-model.lazy="date['SAT'].value"
                            />
                          </div>
                          <div class="mr-0">
                            <currency-ptd
                              :classC="[
                                'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
                                `${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
                                protectionRateInvalid(room.priceMin, room.priceMax, date['SUN'].value) 
                                  ? 'protection-border-danger' 
                                  : ''
                              ].filter(Boolean).join(' ')" 
                              :options="
                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                              "
                              :disabled="date['SUN'].disable"
                              v-model.lazy="date['SUN'].value"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mr-auto pl-2 text-center" style="width: 94px;"></div>
                </div>
                <v-row
                  class="mt-0"
                  v-if="roomIndex === 0 && indexPlan === 0"
                >
                  <v-col class="pt-0 pb-0">
                    <v-btn
                      color="primary"
                      outlined
                      x-small
                      @click="addDatePriodSpecialPrice()"
                    >
                      <i class="icon-add fs-14"></i>
                      <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
            <hr class="mb-0" />
          </template>
        </div>
      </template>
      <template v-if="popupBatchUpdate.price.selectedRoomType.length === 0 || planSelect.length === 0">
        <v-col class="text-center">
          <p style="color: #484646">{{ $t("NO_DATA") }}</p>
        </v-col>
      </template>
    </div>
    <v-row class="config-price" v-else-if="!popupBatchUpdate.isLoading">
      <template>
        <v-col class="pt-0 pb-0" md="12">
          <v-row class="d-un-sticky">
            <v-col md="12" class="pt-0 pb-0">
              <v-row>
                <v-col class="text-center font-weight-bold" md="2">{{
                  $t("DATE_RANGE")
                }}</v-col>
                <v-col
                  class="text-center font-weight-bold"
                  v-for="item in popupBatchUpdate.daysOfWeek"
                  :key="item.code"
                  >{{ item.value }}</v-col
                >
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="12" class="pb-0 pt-2">
              <v-row class="align-center">
                <v-col md="12" class="pb-0 pt-0 fs-12 d-date">
                  <v-row
                    v-for="(date, indexDate) in massDate" :key="indexDate"
                    class="small-gutters mb-2"
                  >
                    <v-col class="pb-0 pt-0 d-flex align-items-center" md="2">
                      <date-picker
                        :disabled-date="notBeforeToday"
                        @input="changDateMass(date)"
                        :confirm="true"
                        :confirm-text="$t('CONFIRM')"
                        :clearable="false"
                        :popup-class="'popup-calendar-desktop-detailhotel'"
                        v-model="date.dateSelect"
                        :lang="languageDate"
                        :format="'DD/MM/YYYY'"
                        :shortcuts="[]"
                        range
                        placeholder="Select date range"
                      >
                      </date-picker>
                      <v-btn color="red" v-if="massDate.length > 1" @click="removePeriodSpecialPriceMass(indexDate)" icon small><i class="icon-delete fs-16"></i></v-btn>
                    </v-col>
                    <v-col class="pb-0 pt-0 d-flex align-items-center">
                      <v-btn color="primary" @click="copySpecialPriceMass(indexDate)" :title="$t('COPY')" icon small><i class="icon-content_paste_go fs-16"></i></v-btn>
                      <currency-ptd
														:classC="'w-100 v-input__slot mb-0 mx-input py-0 rounded'"  
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														"
                            :disabled="date['MON'].disable"
														v-model.lazy="date['MON'].value"
													/>
                    </v-col>
                    <v-col class="pb-0 pt-0">
                      <currency-ptd
														:classC="'w-100 v-input__slot mb-0 mx-input py-0 rounded'"  
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														"
                            :disabled="date['TUE'].disable"
														v-model.lazy="date['TUE'].value"
													/>
                    </v-col>
                    <v-col class="pb-0 pt-0">
                      <currency-ptd
														:classC="'w-100 v-input__slot mb-0 mx-input py-0 rounded'"  
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														"
                            :disabled="date['WED'].disable"
														v-model.lazy="date['WED'].value"
													/>
                    </v-col>
                    <v-col class="pb-0 pt-0">
                      <currency-ptd
														:classC="'w-100 v-input__slot mb-0 mx-input py-0 rounded'"  
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														"
                            :disabled="date['THU'].disable"
														v-model.lazy="date['THU'].value"
													/>
                    </v-col>
                    <v-col class="pb-0 pt-0">
                      <currency-ptd
														:classC="'w-100 v-input__slot mb-0 mx-input py-0 rounded'"  
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														"
                            :disabled="date['FRI'].disable"
														v-model.lazy="date['FRI'].value"
													/>
                    </v-col>
                    <v-col class="pb-0 pt-0">
                      <currency-ptd
														:classC="'w-100 v-input__slot mb-0 mx-input py-0 rounded'"  
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														"
                            :disabled="date['SAT'].disable"
														v-model.lazy="date['SAT'].value"
													/>
                    </v-col>
                    <v-col class="pb-0 pt-0 d-flex justify-space-between">
                      <currency-ptd
														:classC="'w-100 v-input__slot mb-0 mx-input py-0 rounded'"  
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														"
                            :disabled="date['SUN'].disable"
														v-model.lazy="date['SUN'].value"
													/>
                    </v-col>
                  </v-row>
                  <v-row class="mt-1">
                    <v-col class="pt-0 pb-0">
                      <v-btn
                        color="primary"
                        outlined
                        x-small
                        @click="addDatePriodSpecialPriceMass()"
                      >
                        <v-icon color="#173d8f" small>add</v-icon>
                        <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <hr class="mb-0" />
              <v-row class="mt-3">
                <v-col md="12" class="pt-0 pb-0">
                  <label class="label-title">{{ $t("APPLY_FOR") }}</label>
                </v-col>
                <v-col md="12">
                  <v-expansion-panels v-model="panel" multiple>
                    <v-expansion-panel
                      v-for="room in popupBatchUpdate.price.hasRoomRate"
                    >
                      <v-expansion-panel-header>{{
                        room.romTypeNameI18ns.find(x => x.lang == defaultI18n)
                          .name
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-checkbox
                            color="indigo darken-3"
                            :label="$t('SELECT_ALL')"
                            v-model="room.selectAll"
                            @change="checkAll(room)"
                            class="p-0 pb-1 m-0"
                        />
                        <v-row class="sale-package-info">
                          <v-col
                            md="12"
                            class="pb-0 pt-0"
                            v-for="plan in room.roomRates"
                          >
                            <p class="mb-0">
                             <span class="font-weight-bold "> {{
                                plan.romPlanNameI18ns.find(
                                  x => x.lang == defaultI18n
                                ).name
                              }}</span> (<a
                              class="text-primary text-decoration-underline"
                              @click="checkAllPlan(plan)"
                              >{{$t('SELECT_ALL')}}</a> | <a
                              class="text-primary text-decoration-underline"
                              @click="removeAllPlan(plan)"
                              >{{$t('UN_SELECT_ALL')}}</a>)
                            </p>
                            <v-row>
                              <v-col
                                v-for="detail in plan.ota"
                                md="3"
                                class="pb-0 pt-0"
                              >
                                <v-checkbox
                                  color="primary"
                                  v-model="
                                    popupBatchUpdate.price.roomRateSelect
                                  "
                                  :label="
                                    detail.ota.otaI18n.find(
                                      x => x.lang == defaultI18n
                                    ).name
                                  "
                                  :value="detail.roomrateId"
                                  class="p-0 m-0"
                                >
                                </v-checkbox>
                              </v-col>
                            </v-row>
                            <hr class="mb-2" />
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </template>
    </v-row>

    <div class="text-right pt-3 px-3" v-if="!popupBatchUpdate.isLoading">
      <v-btn color="primary" @click="confirmUpdateSpecialPrice()">
        <template
          >{{ $t("UPDATE") }}</template
        >
      </v-btn>
    </div>
    <delete-dialog @deleteItem="openPopupRoomType" :maxWidth="325" ref="openPopupRoomType">
      <span slot="title">{{ $t("CONFIRM_DELETE_DATA_ENTERED") }}?</span>
    </delete-dialog>

    <!-- Popup xac nhan xoa gia dac biet-->
    <delete-dialog @deleteItem="openPopupBulkUpdate" :maxWidth="325" ref="openPopupBulkUpdate">
      <span slot="title">{{ $t("CONFIRM_DELETE_DATA_ENTERED") }}?</span>
    </delete-dialog>
    <v-dialog v-model="dialogWarning" :persistent="true" width="500" >
			<v-toolbar class="toolbar-update" dense >
				<v-toolbar-title class="text-primary fs-15">
				<strong>{{ $t('WARNING') }}</strong>
				</v-toolbar-title>
			</v-toolbar>
			<div class="content-update">
				<label class="s-label">
				{{ $t('TXT_WARNING_OVER') }}
				</label>
				<div class="mt-3 text-center">
					<v-btn color="primary" @click="closeWarning">
					{{ $t("CONFIRM") }}
					</v-btn>
				</div>
			</div>
		</v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: {
    "date-picker": () => import('vue2-datepicker'),
    "currency-ptd": () => import('@/components/Utils/Currency-input.vue'),
    "delete-dialog": () => import('@/components/Utils/DeleteDialog.vue'),
  },
  data() {
    return {
      dialogWarning: false,
      panel: [0],
      currency: JSON.parse(localStorage.getItem("currency")),
      multiplierOption: {
        prefix: "",
        locale: "vi",
        length: 3,
        precision: 2
      },
      availOptions: {
        locale: "vi",
        length: 3,
        precision: 0
      },
      popupBatchUpdate: {
        isLoading: true,
        price: {
          hasRoomRate: [],
          roomRateSelect: [],
          selectedRoomType: [],
          action: "updateByRoomType",
          delete: {
            options: [
              { text: this.$t("DELETE"), value: -1 },
              { text: this.$t("_ACTIVITY.NO"), value: null }
            ]
          },
          priceByOtasSelected: []
        },
        daysOfWeek: [
          { code: "MON", value: this.$t("MONDAY") },
          { code: "TUE", value: this.$t("TUESDAY") },
          { code: "WED", value: this.$t("WEDNESDAY") },
          { code: "THU", value: this.$t("THURSDAY") },
          { code: "FRI", value: this.$t("FRIDAY") },
          { code: "SAT", value: this.$t("SATURDAY") },
          { code: "SUN", value: this.$t("SUNDAY") }
        ]
      },
      listRoom: [],
      currentDate: moment()
        .startOf("day")
        .toDate(),
      selectedDatePicker: moment()
        .startOf("day")
        .format("YYYY-MM-DD"),
      systemLang: this.$i18n.locale,
      maxDate: moment(this.currentDate)
        .add(2, "year")
        .add(14, "day")
        .format("YYYY-MM-DD"),
      selectedRoom: -1,
      objectCopy: null,
      massDate: [],
      planList: [],
			planSelect: [],
      listOTA: [],
      radioUpdateByRoomType: null,
      radioUpdate: null,
      updateErrors: {},
    };
  },
  computed: {},
  created() {
    this.currency = this.usedCurrency;
    this.initialize();
  },
  watch: {
    radioUpdateByRoomType(newValue, oldValue) {
			if (oldValue && newValue) {
        let check = false;
        this.popupBatchUpdate.price.hasRoomRate.filter(temp =>  this.popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId) ).forEach(hr => {
          hr.roomRates.filter(item => this.planSelect.includes(item.ratePlansId)).forEach(rr => {
            rr.dates.forEach(date => {
              if (date.MON.value || date.TUE.value || date.WED.value || date.THU.value || date.FRI.value || date.SAT.value || date.SUN.value)
              check = true;
              return
            })
          })
        })
        if (check) {
          this.$refs.openPopupRoomType.open()
        }
			}
		},
		radioUpdate(newValue, oldValue) {
			if (oldValue && newValue) {
        let check = false;
        this.popupBatchUpdate.price.hasRoomRate.filter(temp => this.popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId)).forEach(hr => {
          hr.roomRates.filter(item => this.planSelect.includes(item.ratePlansId)).forEach(rr => {
            rr.ota.filter(ota => this.popupBatchUpdate.price.priceByOtasSelected.includes(ota.ota.id)).forEach(d => {
              d.dates.forEach(date => {
                if (date.MON.value || date.TUE.value || date.WED.value || date.THU.value || date.FRI.value || date.SAT.value || date.SUN.value)
                check = true;
                return
              })
            })
          }) 
        })
        if (check) {
          this.$refs.openPopupBulkUpdate.open()
        }
			}
		},
    popupBatchUpdate: {
      handler(val) {
        val.price.hasRoomRate.forEach(room => {
          const arrRoomRateIds = [];
          room.roomRates.forEach(plan => {
            plan.dates.forEach(date => {
                var start = moment(date.dateSelect[0], "YYYY-MM-DD");
                var end = moment(date.dateSelect[1], "YYYY-MM-DD");

                // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
                let day = moment.duration(end.diff(start)).asDays();

                // Reset lại toàn bộ
                if (day < 6) {
                  while (start <= end) {
                    let daysOfWeek = this.formatDateOfWeek(start);
                    // Mở các thứ ở trong khoảng
                    date[daysOfWeek].disable = false;
                    start = moment(start).add(1, "day");
                  }
                } else {
                  // Nếu khoảng ngày trải dài cả tuần thì mở hết.
                  date.MON.disable = false;
                  date.TUE.disable = false;
                  date.WED.disable = false;
                  date.THU.disable = false;
                  date.FRI.disable = false;
                  date.SAT.disable = false;
                  date.SUN.disable = false;
                }
              });
            plan.ota.forEach(detail => {
              detail.dates.forEach(date => {
                var start = moment(date.dateSelect[0], "YYYY-MM-DD");
                var end = moment(date.dateSelect[1], "YYYY-MM-DD");

                // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
                let day = moment.duration(end.diff(start)).asDays();

                // Reset lại toàn bộ
                if (day < 6) {
                  while (start <= end) {
                    let daysOfWeek = this.formatDateOfWeek(start);
                    // Mở các thứ ở trong khoảng
                    date[daysOfWeek].disable = false;
                    start = moment(start).add(1, "day");
                  }
                } else {
                  // Nếu khoảng ngày trải dài cả tuần thì mở hết.
                  date.MON.disable = false;
                  date.TUE.disable = false;
                  date.WED.disable = false;
                  date.THU.disable = false;
                  date.FRI.disable = false;
                  date.SAT.disable = false;
                  date.SUN.disable = false;
                }
              });
              arrRoomRateIds.push(detail.roomrateId);
            });
          });
          let check = true
          arrRoomRateIds.forEach(item => {
            if (!val.price.roomRateSelect.includes(item)) {
              check = false
            }
          })
          room.selectAll = check
        });
        this.updateErrors = {};
      },
      deep: true
    },
    massDate: {
      handler(val) {
        val.forEach(date => {
          var start = moment(date.dateSelect[0], "YYYY-MM-DD");
          var end = moment(date.dateSelect[1], "YYYY-MM-DD");

          // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
          let day = moment.duration(end.diff(start)).asDays();

          // Reset lại toàn bộ
          if (day < 6) {
            while (start <= end) {
              let daysOfWeek = this.formatDateOfWeek(start);
              // Mở các thứ ở trong khoảng
              date[daysOfWeek].disable = false;
              start = moment(start).add(1, "day");
            }
          } else {
            // Nếu khoảng ngày trải dài cả tuần thì mở hết.
            date.MON.disable = false;
            date.TUE.disable = false;
            date.WED.disable = false;
            date.THU.disable = false;
            date.FRI.disable = false;
            date.SAT.disable = false;
            date.SUN.disable = false;
          }
        });
        this.updateErrors = {};
      },
      deep: true
    }
  },
  methods: {
    checkValidate() {
      const dateOfWeek = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
      this.updateErrors = {};
      let errors = [];
      this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
          //lấy priceMin, priceMax của từng loại phòng
        const priceMax = room.priceMax;
        const priceMin = room.priceMin;
        const message = priceMax != null && priceMin != null ? 
          this.$t("SAFE_PRICE_RANGE.PROTECTION_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax), priceMin: this.formatCurrencyWithSymbol(priceMin)}) :
            priceMax != null ? 
            this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax)}) :
            this.$t("SAFE_PRICE_RANGE.MINIMUM_RATE_INPUT_INVALID", {priceMin: this.formatCurrencyWithSymbol(priceMin)});
        if (this.popupBatchUpdate.price.selectedRoomType.includes(room.roomTypeId)) {
          const roomRates = room.roomRates.filter(item => this.planSelect.includes(item.ratePlansId));
          roomRates.forEach(plan => {
            if (!errors.some(error => error.id === `${room.roomTypeId}_${plan.ratePlansId}`)) {
              if (this.popupBatchUpdate.price.action === "updateByRoomType") {
                plan.dates.some(date => 
                  dateOfWeek.some(day => {
                    if (
                        (priceMin != null && date[day].value && parseFloat(priceMin) > parseFloat(date[day].value)) ||
                        (priceMax != null && date[day].value && parseFloat(priceMax) < parseFloat(date[day].value))
                    ) {
                        errors.push({ id: `${room.roomTypeId}_${plan.ratePlansId}`, message });
                        return true;
                    }
                    return false;
                  })
                )
              }
              if (this.popupBatchUpdate.price.action === "update") {
                plan.ota.some(detail => 
                  detail.dates.some(date => 
                    dateOfWeek.some(day => {
                      if (
                          (priceMin != null && date[day].value && parseFloat(priceMin) > parseFloat(date[day].value)) ||
                          (priceMax != null && date[day].value && parseFloat(priceMax) < parseFloat(date[day].value))
                      ) {
                          errors.push({ id: `${room.roomTypeId}_${plan.ratePlansId}`, message });
                          return true;
                      }
                      return false;
                    })
                  )
                );
              }
            }
          });
        }
      });
      if (errors.length > 0) {
        const errorsObject = Object.fromEntries(
            [...new Map(errors.map(item => [item.id, item.message]))]
        );
        this.updateErrors = errorsObject;
      }
      return Object.keys(this.updateErrors).length == 0;
    },
    closeWarning() {
			this.planSelect = [];
			this.dialogWarning = false
		},
    checkProductUpdate() {
			
			let dataUpdate = 0;
      this.popupBatchUpdate.price.hasRoomRate.forEach(e => {
        if ( this.popupBatchUpdate.price.selectedRoomType.includes(e.roomTypeId)) {
          
          e.roomRates.forEach(rr => {
            if( this.planSelect.includes(rr.ratePlansId)) {
              dataUpdate += 1;
            }
          })
        }
      });
			if (dataUpdate > 50) {
				this.dialogWarning = true;
			}
		},
    openPopupRoomType() {
			this.popupBatchUpdate.price.hasRoomRate.forEach(hr => {
				hr.roomRates.forEach(rr => {
					rr.dates.forEach(date => {
              date.MON.value = null;
              date.TUE.value = null;
              date.WED.value = null;
              date.THU.value = null;
              date.FRI.value = null;
              date.SAT.value = null;
              date.SUN.value = null;
					})
				})
			})
		},
		openPopupBulkUpdate() {
			this.popupBatchUpdate.price.hasRoomRate.forEach(hr => {
				hr.roomRates.forEach(rr => {
					rr.ota.forEach(d => {
						d.dates.forEach(date => {
							date.MON.value = null;
              date.TUE.value = null;
              date.WED.value = null;
              date.THU.value = null;
              date.FRI.value = null;
              date.SAT.value = null;
              date.SUN.value = null;
						})
					})
				}) 
			})
		},
    checkAll(room) {
      const arrRoomRateIds = [];
      const roomRateSelect = Array.from(new Set( this.popupBatchUpdate.price.roomRateSelect.map(JSON.stringify))).map(JSON.parse);
      room.roomRates.forEach(r => {
        r.ota.forEach(ota => {
          arrRoomRateIds.push(ota.roomrateId);
        })
      })
      
      if (room.selectAll) {
        this.popupBatchUpdate.price.roomRateSelect = Array.from(new Set( roomRateSelect.concat(arrRoomRateIds).map(JSON.stringify))).map(JSON.parse);
      } else {
        arrRoomRateIds.forEach(item => {
          if (roomRateSelect.includes(item)) {
            roomRateSelect.splice(roomRateSelect.indexOf(item), 1)
          }
        })
        this.popupBatchUpdate.price.roomRateSelect = Array.from(new Set( roomRateSelect.map(JSON.stringify))).map(JSON.parse);
      }
    },
    checkAllPlan(plan) {
      const arrRoomRateIds = [];
      const roomRateSelect = Array.from(new Set( this.popupBatchUpdate.price.roomRateSelect.map(JSON.stringify))).map(JSON.parse);
      plan.ota.forEach(ota => {
        arrRoomRateIds.push(ota.roomrateId);
      })
      this.popupBatchUpdate.price.roomRateSelect = Array.from(new Set( roomRateSelect.concat(arrRoomRateIds).map(JSON.stringify))).map(JSON.parse);
    },
    removeAllPlan(plan) {
      const arrRoomRateIds = [];
      const roomRateSelect = Array.from(new Set( this.popupBatchUpdate.price.roomRateSelect.map(JSON.stringify))).map(JSON.parse);
        plan.ota.forEach(ota => {
          arrRoomRateIds.push(ota.roomrateId);
        })
        arrRoomRateIds.forEach(item => {
          if (roomRateSelect.includes(item)) {
            roomRateSelect.splice(roomRateSelect.indexOf(item), 1)
          }
        })
        this.popupBatchUpdate.price.roomRateSelect = Array.from(new Set( roomRateSelect.map(JSON.stringify))).map(JSON.parse);
    },
    changeAction() {
      this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
        room.roomRates.forEach(plan => {
          plan.ota.forEach(detail => {
            detail.dates.forEach(date => {
              date.MON.value = null;
              date.TUE.value = null;
              date.WED.value = null;
              date.THU.value = null;
              date.FRI.value = null;
              date.SAT.value = null;
              date.SUN.value = null;
            });
          });
        });
      });
      this.updateErrors = {};
    },
    async initialize() {
      this.popupBatchUpdate.isLoading = true;
      // Nếu là search thì không lấy lại list OTA nữa, ko dùng OTA đầu tiên như khi mới vào.
      this.currency = this.priceOptionsVi.suffix;
      this.massDate.push({
        dateSelect: [
          new Date(moment(this.currentDate).format("YYYY-MM-DD")),
          new Date(
            moment(this.currentDate)
              .add(1, "day")
              .format("YYYY-MM-DD")
          )
        ],
        MON: {
          value: null,
          disable: true
        },
        TUE: {
          value: null,
          disable: true
        },
        WED: {
          value: null,
          disable: true
        },
        THU: {
          value: null,
          disable: true
        },
        FRI: {
          value: null,
          disable: true
        },
        SAT: {
          value: null,
          disable: true
        },
        SUN: {
          value: null,
          disable: true
        }
      });
      await syncota.getAllOTA({ keyword: "", status: 1 }).then((res) => {
				if (res.responseCode === 0) {
					this.listOTA = res.data.filter(o => o.otaCode !== 'EZ_PMS').map((x) => {
						return {
							value: x.id,
							text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
						};
					});
					this.listOTA = this.listOTA.filter((x) => x.value);
          this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
          this.getAllRoomDefault();
				} else {
					_alert(res, this.$t(res.data), false);
				}
				});
      
    },
    loadListRoom(data) {
      this.listRoom = [];
      this.listRoom = this.listRoom.concat(
        data.map(room => {
          return {
            value: room.roomTypeId,
            text: room.romTypeNameI18ns.find(x => x.lang === this.defaultI18n).name
          };
        })
      );
      this.popupBatchUpdate.isLoading = false;
    },
    inDays(d1, d2) {
      var t2 = d2.getTime();
      var t1 = d1.getTime();

      return parseInt((t2 - t1) / (24 * 3600 * 1000));
    },
    copyPrice(date) {
      var value = null;
      if (!date.MON.disable) {
        value = date.MON.value;
      } else if (!date.TUE.disable) {
        value = date.TUE.value;
      } else if (!date.WED.disable) {
        value = date.WED.value;
      } else if (!date.THU.disable) {
        value = date.THU.value;
      } else if (!date.FRI.disable) {
        value = date.FRI.value;
      } else if (!date.SAT.disable) {
        value = date.SAT.value;
      } else if (!date.SUN.disable) {
        value = date.SUN.value;
      }
      date.MON.value = !date.MON.disable ? value : null;
      date.TUE.value = !date.TUE.disable ? value : null;
      date.WED.value = !date.WED.disable ? value : null;
      date.THU.value = !date.THU.disable ? value : null;
      date.FRI.value = !date.FRI.disable ? value : null;
      date.SAT.value = !date.SAT.disable ? value : null;
      date.SUN.value = !date.SUN.disable ? value : null;
    },
    copySpecialPriceMass(index) {
      var value = null;
      if (!this.massDate[index].MON.disable) {
        value = this.massDate[index].MON.value;
      } else if (!this.massDate[index].TUE.disable) {
        value = this.massDate[index].TUE.value;
      } else if (!this.massDate[index].WED.disable) {
        value = this.massDate[index].WED.value;
      } else if (!this.massDate[index].THU.disable) {
        value = this.massDate[index].THU.value;
      } else if (!this.massDate[index].FRI.disable) {
        value = this.massDate[index].FRI.value;
      } else if (!this.massDate[index].SAT.disable) {
        value = this.massDate[index].SAT.value;
      } else if (!this.massDate[index].SUN.disable) {
        value = this.massDate[index].SUN.value;
      }
      this.massDate[index].MON.value = !this.massDate[index].MON.disable
        ? value
        : null;
      this.massDate[index].TUE.value = !this.massDate[index].TUE.disable
        ? value
        : null;
      this.massDate[index].WED.value = !this.massDate[index].WED.disable
        ? value
        : null;
      this.massDate[index].THU.value = !this.massDate[index].THU.disable
        ? value
        : null;
      this.massDate[index].FRI.value = !this.massDate[index].FRI.disable
        ? value
        : null;
      this.massDate[index].SAT.value = !this.massDate[index].SAT.disable
        ? value
        : null;
      this.massDate[index].SUN.value = !this.massDate[index].SUN.disable
        ? value
        : null;
    },
    changDate(ota) {
      if (this.popupBatchUpdate.price.action !== 'updateByRoomType') {
        let arrDate = [];
        ota.dates.forEach(element => {
          arrDate.push(element.dateSelect);
        });
        this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
          room.roomRates.forEach(plan => {
            plan.ota.forEach(detail => {
              detail.dates.forEach((date, index) => {
                date.MON.disable = true;
                date.TUE.disable = true;
                date.WED.disable = true;
                date.THU.disable = true;
                date.FRI.disable = true;
                date.SAT.disable = true;
                date.SUN.disable = true;
                date.dateSelect = arrDate[index];
              });
            });
          });
        });
      } else {
        let arrDate = [];
        ota.dates.forEach(element => {
          arrDate.push(element.dateSelect);
        });
        this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
          room.roomRates.forEach(detail => {
              detail.dates.forEach((date, index) => {
                date.MON.disable = true;
                date.TUE.disable = true;
                date.WED.disable = true;
                date.THU.disable = true;
                date.FRI.disable = true;
                date.SAT.disable = true;
                date.SUN.disable = true;
                date.dateSelect = arrDate[index];
              });
          });
        });
      }
      
    },
    changDateMass(date) {
      date.MON.disable = true;
      date.TUE.disable = true;
      date.WED.disable = true;
      date.THU.disable = true;
      date.FRI.disable = true;
      date.SAT.disable = true;
      date.SUN.disable = true;
    },
    async getAllRoomDefault() {
      this.popupBatchUpdate.price.hasRoomRate = [];
      const roomRateUpdateStore = JSON.parse(localStorage.getItem("roomRateUpdate"));
      await restriction.getAllRoomTyeHasRoomRate().then(res => {
        if (res.responseCode == 0) {
          let fromDateListOfPeriod = moment(this.currentDate).format(
            "YYYY-MM-DD"
          );
          let toDateListOfPeriod = moment(this.currentDate)
            .add(1, "day")
            .format("YYYY-MM-DD");
          // List phòng đã có room rate cho cập nhật giá và giá đặc biệt
          this.planList = [];
          res.data.forEach(x => {
            var temp = {
              roomTypeId: x.id,
              romTypeNameI18ns: x.roomTypeI18n,
              roomRates: [],
              selectAll: false,
              priceMin: x.priceMin,
              priceMax: x.priceMax
            };
            x.ratePlans.forEach(y => {
              let plan = {
								value: y.id,
								text: y.i18ns.find((y) => y.lang == this.defaultI18n).name,
							};
							this.planList.push(plan);
							this.planList = Array.from(new Set(this.planList.map(JSON.stringify))).map(JSON.parse)
              var temp2 = [];
              y.roomRates.filter(o => o.ota.otaCode !== 'EZ_PMS').forEach(z => {
                if ( !z.linkedRoomRateId) {
                    temp2.push({
                    roomrateId: z.id,
                    dates: [
                      {
                        dateSelect: [
                          new Date(fromDateListOfPeriod),
                          new Date(toDateListOfPeriod)
                        ],
                        MON: {
                          value: null,
                          disable: true
                        },
                        TUE: {
                          value: null,
                          disable: true
                        },
                        WED: {
                          value: null,
                          disable: true
                        },
                        THU: {
                          value: null,
                          disable: true
                        },
                        FRI: {
                          value: null,
                          disable: true
                        },
                        SAT: {
                          value: null,
                          disable: true
                        },
                        SUN: {
                          value: null,
                          disable: true
                        }
                      }
                    ],
                    ota: z.ota,
                    multiplier: 1,
                    plus: 0
                  });
                }
              });
              if (temp2.length > 0) {
                temp.roomRates.push({
                  romPlanNameI18ns: y.i18ns,
                  ratePlansId: y.id,
                  ota: temp2,
                  dates: [
                      {
                        dateSelect: [
                          new Date(fromDateListOfPeriod),
                          new Date(toDateListOfPeriod)
                        ],
                        MON: {
                          value: null,
                          disable: true
                        },
                        TUE: {
                          value: null,
                          disable: true
                        },
                        WED: {
                          value: null,
                          disable: true
                        },
                        THU: {
                          value: null,
                          disable: true
                        },
                        FRI: {
                          value: null,
                          disable: true
                        },
                        SAT: {
                          value: null,
                          disable: true
                        },
                        SUN: {
                          value: null,
                          disable: true
                        }
                      }
                  ],
                  multiplier: 1,
                  plus: 0,
                  selectedOta: roomRateUpdateStore.OtaId && roomRateUpdateStore.OtaId != -1 
                                ? this.listOTA.find(x => x.value == roomRateUpdateStore.OtaId) && y.roomRates.map(ota => ota.ota.id).includes(roomRateUpdateStore.OtaId) ?  [roomRateUpdateStore.OtaId] : [] 
                                : roomRateUpdateStore.OtaId && roomRateUpdateStore.OtaId == -1 ?  y.roomRates.map(ota => ota.ota.id) : [],
									textSearch: ''
                });
              }
            });
            if (temp.roomRates.length > 0) {
               this.popupBatchUpdate.price.hasRoomRate.push(temp);
            }
           
          });
          this.loadListRoom(this.popupBatchUpdate.price.hasRoomRate);
          this.popupBatchUpdate.price.selectedRoomType = roomRateUpdateStore.roomId && roomRateUpdateStore.roomId != -1 ? [roomRateUpdateStore.roomId] 
                                                          : [];
          this.planSelect = roomRateUpdateStore.planId && roomRateUpdateStore.planId != -1 ? [roomRateUpdateStore.planId] 
                                                          : [];
          this.popupBatchUpdate.price.priceByOtasSelected =  roomRateUpdateStore.OtaId && roomRateUpdateStore.OtaId != -1 ? [roomRateUpdateStore.OtaId] : [];
          this.popupBatchUpdate.price.roomRateSelect = [roomRateUpdateStore.planId];
          this.panel = this.popupBatchUpdate.price.hasRoomRate.map((k, i) => i)
        }
      });
    },
    changeRoomSelect(value) {
      this.radioUpdate = null;
      this.radioUpdateByRoomType = null;
    },
    copyMasterRate(detail) {
      if (this.popupBatchUpdate.price.action !== 'updateByRoomType') {
        if (!this.radioUpdate) return;
        const arrUpdate = [];
				// this.popupBatchUpdate.price.hasRoomRate.forEach(r => {
				// 	if (this.popupBatchUpdate.price.selectedRoomType.includes(r.roomTypeId)) {
				// 		r.roomRates.forEach(rp => {
				// 			if (this.planSelect.includes(rp.ratePlansId)) {
				// 				rp.ota.forEach(rr => {
				// 					if (this.popupBatchUpdate.price.priceByOtasSelected.includes(rr.ota.id)) {
				// 						arrUpdate.push(rr.dates)
				// 					}
				// 				})
				// 			}
				// 		})
				// 	}
				// })
        this.popupBatchUpdate.price.hasRoomRate.forEach(r => {
					if (r.roomTypeId  === this.radioUpdate.split("|")[0]) {
						r.roomRates.forEach(rp => {
							if (rp.ratePlansId  === this.radioUpdate.split("|")[1]) {
								rp.ota.forEach(rr => {
									if (rr.ota.id  === this.radioUpdate.split("|")[2]) {
										arrUpdate.push(rr.dates)
									}
								})
							}
						})
					}
				})
        let arrMap = [];
        arrMap = arrUpdate[0];
        arrMap.forEach((element, index) => {
            detail.dates[index]["MON"].value = detail.dates[index]["MON"].disable ? null :  element["MON"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["TUE"].value = detail.dates[index]["TUE"].disable ? null : element["TUE"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["WED"].value = detail.dates[index]["WED"].disable ? null : element["WED"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["THU"].value = detail.dates[index]["THU"].disable ? null : element["THU"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["FRI"].value = detail.dates[index]["FRI"].disable ? null : element["FRI"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["SAT"].value = detail.dates[index]["SAT"].disable ? null : element["SAT"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["SUN"].value = detail.dates[index]["SUN"].disable ? null : element["SUN"].value*detail.multiplier + +detail.plus;
        });
      } else {
        if (!this.radioUpdateByRoomType) return
        let arrMap = [];
        arrMap = this.popupBatchUpdate.price.hasRoomRate.filter(temp =>
                temp.roomTypeId === this.radioUpdateByRoomType.split("|")[0]
            )[0].roomRates.filter(item => item.ratePlansId === this.radioUpdateByRoomType.split("|")[1])[0].dates;
        arrMap.forEach((element, index) => {
            detail.dates[index]["MON"].value = detail.dates[index]["MON"].disable ? null :  element["MON"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["TUE"].value = detail.dates[index]["TUE"].disable ? null : element["TUE"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["WED"].value = detail.dates[index]["WED"].disable ? null : element["WED"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["THU"].value = detail.dates[index]["THU"].disable ? null : element["THU"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["FRI"].value = detail.dates[index]["FRI"].disable ? null : element["FRI"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["SAT"].value = detail.dates[index]["SAT"].disable ? null : element["SAT"].value*detail.multiplier + +detail.plus;
            detail.dates[index]["SUN"].value = detail.dates[index]["SUN"].disable ? null : element["SUN"].value*detail.multiplier + +detail.plus;
        });
      }

     
    },
    copyMaster(detail) {
      this.objectCopy = [...detail];
    },
    pasteMaster(detail) {
      if (this.objectCopy) {
        this.objectCopy.forEach((element, index) => {
          detail.dates[index]["MON"].value = element["MON"].value;
          detail.dates[index]["TUE"].value = element["TUE"].value;
          detail.dates[index]["WED"].value = element["WED"].value;
          detail.dates[index]["THU"].value = element["THU"].value;
          detail.dates[index]["FRI"].value = element["FRI"].value;
          detail.dates[index]["SAT"].value = element["SAT"].value;
          detail.dates[index]["SUN"].value = element["SUN"].value;
        });
      }
    },
    confirmUpdateSpecialPrice() {
      if (!this.checkValidate()) return;
      let arrDate = [];
      let check = false;
      if (this.popupBatchUpdate.price.action === "massUpdate") {
        this.massDate.forEach(date => {
          arrDate.push(date.dateSelect);
        });
      } else if (this.popupBatchUpdate.price.action === "updateByRoomType") {
        this.popupBatchUpdate.price.hasRoomRate[0].roomRates[0].dates.forEach(
          date => {
            arrDate.push(date.dateSelect);
          }
        );
      } else {
        this.popupBatchUpdate.price.hasRoomRate[0].roomRates[0].ota[0].dates.forEach(
          date => {
            arrDate.push(date.dateSelect);
          }
        );
      }

      // let noted;
      // arrDate.forEach(x => {
      //   if (this.get_day_of_time(new Date(x[0]), new Date(x[1])) > 365) {
      //       _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
      //       check = true;
      //       return true
      //   }
      //   if (!noted) {
      //     noted = moment(x[1], "YYYY/MM/DD");
      //     return true;
      //   }
      //   if (moment(x[0], "YYYY/MM/DD") <= noted) {
      //     _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
      //     check = true;
      //   } else {
      //     noted = moment(x[1], "YYYY/MM/DD");
      //   }
      // });

      const dates = [];
      arrDate.forEach((date) => {
        if (this.get_day_of_time(new Date(date[0]), new Date(date[1])) > 365) {
          _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
          check = true;
          return true;
        }
        let fromDate = moment(date[0], "YYYY-MM-DD");
        let toDate = moment(date[1], "YYYY-MM-DD");
        while (fromDate <= toDate) {
          dates.push(fromDate.format("YYYY-MM-DD"));
          fromDate = moment(fromDate).add(1, "day");
        }
      });
      if (dates.filter((item, index) => dates.indexOf(item) !== index).length > 0) {
        _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
        return;
      }

      var body = [];
      var bodyDelete = [];
      if (this.popupBatchUpdate.price.action === "massUpdate") {
        this.popupBatchUpdate.price.roomRateSelect.forEach(detail => {
          var dateValue = [];
          this.massDate.forEach(date => {
            let fromDate = moment(date.dateSelect[0], "YYYY/MM/DD");
            let toDate = moment(date.dateSelect[1], "YYYY/MM/DD");
            while (fromDate <= toDate) {
              let daysOfWeek = this.formatDateOfWeek(fromDate);

              if (
                date[daysOfWeek].value != null &&
                date[daysOfWeek].value != "0"
              ) {
                dateValue.push({
                  apply: fromDate.format("YYYY-MM-DD"),
                  value: date[daysOfWeek].value
                });
              }
              fromDate = moment(fromDate).add(1, "day");
            }
          });
          if (dateValue.length > 0) {
            body.push({
              id: detail,
              dates: dateValue
            });
          }
        });
      }  else if (this.popupBatchUpdate.price.action === "updateByRoomType") {
        if (this.popupBatchUpdate.price.selectedRoomType.length === 0 || this.planSelect.length === 0) {
					_alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
					return
				}
        this.popupBatchUpdate.price.hasRoomRate.filter(temp =>  this.popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId) ).forEach(room => {
          room.roomRates.filter(item => this.planSelect.includes(item.ratePlansId)).forEach(plan => {
            var dateValue = [];
            plan.dates.forEach(date => {
              let fromDate = moment(date.dateSelect[0], "YYYY/MM/DD");
              let toDate = moment(date.dateSelect[1], "YYYY/MM/DD");
              while (fromDate <= toDate) {
                let daysOfWeek = this.formatDateOfWeek(fromDate);

                if (
                  date[daysOfWeek].value != null &&
                  date[daysOfWeek].value != "0"
                ) {
                  dateValue.push({
                    apply: fromDate.format("YYYY-MM-DD"),
                    value: date[daysOfWeek].value
                  });
                }
                fromDate = moment(fromDate).add(1, "day");
              }
            });
            plan.ota.filter((temp) => plan.selectedOta.includes(temp.ota.id)).forEach(detail => {
              if (dateValue.length > 0) {
                body.push({
                  id: detail.roomrateId,
                  dates: dateValue
                });
              }
            });
          });
        });
      } else {
        if (this.popupBatchUpdate.price.selectedRoomType.length === 0 || this.planSelect.length === 0 || this.popupBatchUpdate.price.priceByOtasSelected.length === 0) {
					_alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
					return
				}
        this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
          room.roomRates.forEach(plan => {
            plan.ota.forEach(detail => {
              var dateValue = [];
              var dateValueDelete = [];
              detail.dates.forEach(date => {
                let fromDate = moment(date.dateSelect[0], "YYYY/MM/DD");
                let toDate = moment(date.dateSelect[1], "YYYY/MM/DD");
                while (fromDate <= toDate) {
                  let daysOfWeek = this.formatDateOfWeek(fromDate);

                  if (
                    date[daysOfWeek].value != null &&
                    date[daysOfWeek].value != "0"
                  ) {
                    dateValue.push({
                      apply: fromDate.format("YYYY-MM-DD"),
                      value: date[daysOfWeek].value
                    });
                    dateValueDelete.push(fromDate.format("YYYY-MM-DD"));
                  }
                  fromDate = moment(fromDate).add(1, "day");
                }
              });
              if (dateValue.length > 0) {
                body.push({
                  id: detail.roomrateId,
                  dates: dateValue
                });
                bodyDelete.push({
                  id: detail.roomrateId,
                  dates: dateValueDelete
                });
              }
            });
          });
        });
      }
      this.popupBatchUpdate.isLoading = true;
      if (
        this.popupBatchUpdate.price.action === "update" ||
        this.popupBatchUpdate.price.action === "massUpdate" ||
        this.popupBatchUpdate.price.action === "updateByRoomType"
      ) {
        if (!check && body.length > 0) {
          this.popupBatchUpdate.isLoading = true;
          body.forEach(item => {
            item.dates.forEach(e => {
              e.value = this.formatMoney(+e.value, this.usedCurrency)
            })
          })
          sale_room
            .updateSpecialPrice(body)
            .then(res => {
              _alert(res, this.$t(res.data), false);
            })
            .finally(() => (this.popupBatchUpdate.isLoading = false));
        } else {
          _alert(null, this.$t("PRICE_OR_OTA_IS_REQUIRED"));
          this.popupBatchUpdate.isLoading = false
        }
      } else {
        if (!check && bodyDelete.length > 0) {
          this.popupBatchUpdate.isLoading = true;
          sale_room
            .deleteSpecialPrice(bodyDelete)
            .then(res => {
              _alert(res, this.$t(res.data), false);
            })
            .finally(() => (this.popupBatchUpdate.isLoading = false));
        } else {
          _alert(null, this.$t("PLS_CHOOSE_ONE_SELECT_BOX"));
          this.popupBatchUpdate.isLoading = false
        }
      }
    },
    addDatePriodSpecialPriceMass() {
      let prevPeriod = this.massDate[this.massDate.length - 1];
      const tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 365*2);
      if (
        new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >=
        tomorrow
      ) {
        return;
      }
      let from = moment(prevPeriod.dateSelect[1])
        .add(1, "day")
        .format("YYYY-MM-DD");
      let to = moment(prevPeriod.dateSelect[1])
        .add(2, "day")
        .format("YYYY-MM-DD");
      this.massDate.push({
        dateSelect: [new Date(from), new Date(to)],
        MON: {
          value: null,
          disable: true
        },
        TUE: {
          value: null,
          disable: true
        },
        WED: {
          value: null,
          disable: true
        },
        THU: {
          value: null,
          disable: true
        },
        FRI: {
          value: null,
          disable: true
        },
        SAT: {
          value: null,
          disable: true
        },
        SUN: {
          value: null,
          disable: true
        }
      });
    },
    addDatePriodSpecialPrice() {
      if (this.popupBatchUpdate.price.action !== 'updateByRoomType') {
        let prevPeriod = this.popupBatchUpdate.price.hasRoomRate[0].roomRates[0]
          .ota[0].dates[
          this.popupBatchUpdate.price.hasRoomRate[0].roomRates[0].ota[0].dates
            .length - 1
        ];
        const tomorrow = new Date();
        tomorrow.setDate(new Date().getDate() + 365*2);
        if (
          new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >=
          tomorrow
        ) {
          return;
        }
        let from = moment(prevPeriod.dateSelect[1])
          .add(1, "day")
          .format("YYYY-MM-DD");
        let to = moment(prevPeriod.dateSelect[1])
          .add(2, "day")
          .format("YYYY-MM-DD");
        this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
          room.roomRates.forEach(plan => {
            plan.ota.forEach(detail => {
              detail.dates.push({
                dateSelect: [new Date(from), new Date(to)],
                MON: {
                  value: null,
                  disable: true
                },
                TUE: {
                  value: null,
                  disable: true
                },
                WED: {
                  value: null,
                  disable: true
                },
                THU: {
                  value: null,
                  disable: true
                },
                FRI: {
                  value: null,
                  disable: true
                },
                SAT: {
                  value: null,
                  disable: true
                },
                SUN: {
                  value: null,
                  disable: true
                }
              });
            });
          });
        });
      } else {
        // popupBatchUpdate.price.hasRoomRate.filter((temp) => popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId) 
        // && temp.roomRates.filter(item => planSelect.includes(item.ratePlansId)).length > 0);

        console.log(this.popupBatchUpdate.price.hasRoomRate)

        let prevPeriod = this.popupBatchUpdate.price.hasRoomRate[0].roomRates[0]
          .dates[
          this.popupBatchUpdate.price.hasRoomRate[0].roomRates[0].dates
            .length - 1
        ];
        const tomorrow = new Date();
        tomorrow.setDate(new Date().getDate() + 365*2);
        if (
          new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >=
          tomorrow
        ) {
          return;
        }
        let from = moment(prevPeriod.dateSelect[1])
          .add(1, "day")
          .format("YYYY-MM-DD");
        let to = moment(prevPeriod.dateSelect[1])
          .add(2, "day")
          .format("YYYY-MM-DD");
        this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
          room.roomRates.forEach(detail => {
              detail.dates.push({
                dateSelect: [new Date(from), new Date(to)],
                MON: {
                  value: null,
                  disable: true
                },
                TUE: {
                  value: null,
                  disable: true
                },
                WED: {
                  value: null,
                  disable: true
                },
                THU: {
                  value: null,
                  disable: true
                },
                FRI: {
                  value: null,
                  disable: true
                },
                SAT: {
                  value: null,
                  disable: true
                },
                SUN: {
                  value: null,
                  disable: true
                }
              });
          });
        });
      }
      
    },
    removePeriodSpecialPrice(index) {
      if (this.popupBatchUpdate.price.action !== 'updateByRoomType') {
        this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
            room.roomRates.forEach(plan => {
              plan.ota.forEach(detail => {
                detail.dates.splice(index, 1);
              });
            });
          });
      } else {
        this.popupBatchUpdate.price.hasRoomRate.forEach(room => {
            room.roomRates.forEach(detail => {
                detail.dates.splice(index, 1);
            });
          });
      }
      
    },
    removePeriodSpecialPriceMass(index) {
      this.massDate.splice(index, 1);
    },
    formatDateOfWeek(date) {
      let dayOfWeek;
      switch (date.day()) {
        case 0: {
          dayOfWeek = "SUN";
          break;
        }
        case 1: {
          dayOfWeek = "MON";
          break;
        }
        case 2: {
          dayOfWeek = "TUE";
          break;
        }
        case 3: {
          dayOfWeek = "WED";
          break;
        }
        case 4: {
          dayOfWeek = "THU";
          break;
        }
        case 5: {
          dayOfWeek = "FRI";
          break;
        }
        case 6: {
          dayOfWeek = "SAT";
          break;
        }
      }
      return dayOfWeek;
    },
    _moment: moment
  }
};
</script>
